import { Link } from "react-router-dom";
import { Logo } from "../Logo";

const EXPLORE_LINKS = [
  { label: "Home", to: "/" },
  { label: "Podcast", to: "/listen" },
  { label: "Books", to: "/books" },
  { label: "The Muscle School", to: "/themuscleschool" },
  { label: "Join Gold", to: "/gold" },
];

const SUPPORT_LINKS = [
  { label: "Contact / Support", to: "/support" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Refund Policy", to: "/refund-policy" },
  { label: "Digital Delivery and Shipping Policy", to: "/digital-delivery-policy" },
  { label: "Subscription and Cancellation Policy", to: "/subscription-policy" },
  { label: "Your Privacy Choices", to: "/privacy-choices" },
];

export function Footer() {
  return (
    <footer className="w-full bg-background pt-12 pb-8 px-6 lg:px-12 border-t border-border" data-testid="site-footer">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 max-w-7xl mx-auto">
        <div className="flex flex-col gap-4 text-left">
          <Logo variant="wordmark-light" className="h-5 w-auto" testId="footer-logo" />
          <p className="font-subtitle text-xs tracking-wider text-textSecondary uppercase">Built for Earth. Ready for Beyond.</p>
          <p className="font-body text-sm text-textSecondary">Endure Beyond Media LLC.</p>
        </div>

        <div className="flex flex-col gap-3 text-left md:text-center">
          <p className="font-subtitle text-xs uppercase tracking-widest text-textSecondary mb-2">Explore</p>
          {EXPLORE_LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-explore-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="font-body text-base text-foreground hover:text-brandAccent transition-colors duration-200">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex flex-col gap-3 text-left md:text-right">
          <p className="font-subtitle text-xs uppercase tracking-widest text-textSecondary mb-2">Support &amp; Policies</p>
          {SUPPORT_LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-policy-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="font-body text-sm text-textSecondary hover:text-foreground transition-colors duration-200">
              {l.label}
            </Link>
          ))}
        </div>
      </div>

      <p data-testid="footer-copyright" className="mt-10 pt-6 border-t border-border text-center text-xs font-body text-textSecondary w-full">
        © 2027 Endure Beyond Media LLC. A Durahuman Company. All rights reserved.
      </p>
    </footer>
  );
}
